import React, { useState, useEffect, useCallback, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CourceVenueList } from '../uiParts/cource_venues/CourceVenueList';

const CourceVenues = (props) => {
  const [loading, setLoading] = useState(true);
  const [courceVenues, setCourceVenues] = useState([]);
  const [venues, setVenues] = useState([]);
  const { cource } = props;
  // 初期設定データセット
  useEffect(() => {
    console.log("CourceVenues First Start");
    var data = { params: {cource_id: cource}};
    axios.get(`/api/v1/cource_venues`, data)
    .then(resp => {
      console.log("success");
      console.log(resp);
      setCourceVenues(resp.data.cource_venues);
      setVenues(resp.data.venues);
    })
    .catch(e => {
      console.log("error");
      console.log(e.response);
    })
    .finally(() => {
      setLoading(false);
    });
  }, []);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const upsertCourceVenue = async (data) => {
    console.log("upsertCourceVenue Start");
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.post(`/api/v1/cource_venues_upsert`, data)
                  .then(resp => {
                    console.log("upsert success");
                    console.log(resp.data);
                    setCourceVenues(resp.data.cource_venues);
                    setVenues(resp.data.venues);
                    notify("success", "CourceVenues successfully done!");
                  })
                  .catch(e => {
                    console.log("upsert error");
                    console.log(e.response);
                    notify("error", "CourceVenues Error!");
                  })
                  .finally(() => {
                    setLoading(false);
                  });
    return res;
  }

  const onClickUpsertSubmit = (id) => {
    console.log("onClickUpsertSubmit Start");
    setLoading(true);
    var data = { cource_id: cource };
    upsertCourceVenue(data);
  }

  return (
    <>
      {loading ?
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        :
        <Fragment>
          <div className="mb-1 text-end">
            <button onClick={() => onClickUpsertSubmit(cource)} className="btn btn-success" title="Upsert">
              <i className="fas fa-sync-alt" /> 一括巡回会場連携
            </button>
          </div>
          <div className="text-end">
            <p className="badge bg-light text-dark">巡回会場マスタ件数（{venues.length}件）</p>
          </div>
          <p className="badge bg-light text-dark">設定件数（{courceVenues.length}件）</p>
          <CourceVenueList items={courceVenues} />
        </Fragment>
      }
    </>
  );
};

export default CourceVenues;
